import { createSelector } from 'reselect';
import PredesImpcCodeUsageNonComplianceSummaryColumns
  from '../../containers/PredesImpcCodeUsageNonComplianceSummaryColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .PREDES_IMPC_CODE_USAGE_NON_COMPLIANCE_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, PredesImpcCodeUsageNonComplianceSummaryColumns);
